// import React from 'react';
import      {BrowserRouter as Router, Route} from "react-router-dom";
import React, {useEffect, useState} from "react";
import Login from "./component/Auth/Login.js";
import LoginOtp from "./component/Auth/Login-otp.js";
import Home from "./component/Dashboard/Home";
import Dashboard from "./component/Dashboard/Dashboard.js";
import Employee from "./component/Dashboard/Employee.js";
import LoginSso from "./component/Auth/loginSso";

import ProtectedRoute from "./component/Route/ProtectedRoute";
import CreateLeads from "./component/Leads/save";
import BusinessConfig from "./component/Leads/BusinessConfig";
import BusinessConfigInspection from "./component/Leads/BusinessConfigInspection";
import AccountAttributes from "./component/AccountAttributes";
import AccountList from "./component/AccountAttributes/List";
import CreateOpportunities from "./component/Opportunities";
import OpportunityList from "./component/Opportunities/Listing";
import AddNextActivity from "./component/Activity/NextActivity";
import List from "./component/Activity/List";
import EditOpportunities from "./component/Opportunities/Edit";
import LeadListing from "./component/Leads/List";
import ActivityCreate from "./component/Leads/Activitiy";
import ActivityListing from "./component/Leads/Activitiy/List";
import ActivityAccountCreate from "./component/AccountAttributes/Activity";
import ActivityAccountListing from "./component/AccountAttributes/Activity/List";
import ActivityView from "./component/Activity/view";
import opportunityNewActivity from "./component/Activity/New";
import AccountNewActivity from "./component/AccountAttributes/Activity/New";
import LeadNewActivity from "./component/Leads/Activitiy/New";
import CreateTask from "./component/Tasks/save";
import EditTask from "./component/Tasks/Edit";
import Listing from "./component/Tasks/Listing";
import ViewListing from "./component/Tasks/View";
import Profile from "./component/Profile/Profile";
import Notification from "./component/Notification";
import Assignment from "./component/Assignment";
import PageNotFound from "./component/PageNotFound";
import Reject from "./component/Activity/Reject";
import View from "./component/Opportunities/View";
import PostClosure from "./component/Activity/PostClosure";
// import LeadOpportunityList from "./component/Leads/Opportunity/Listing";
// import CreateLeadOpportunities from "./component/Leads/Opportunity/Create";
// import LeadActivity from "./component/Leads/Opportunity/Activity/NextActivity";
import V2OpportunityActivityList from "./component/Activity/V2/List";
import V2OpportunityActivity from "./component/Activity/V2/NextActivity";
import V2ActivityView from "./component/Activity/V2/View";
import LastActivityHistory from "./component/Activity/V2/LastAction";

import Dealer from "./component/Dealer";
import ActivitySave from "./component/Dealer/Activity/Save";
import DealerActivityList from "./component/Dealer/Activity/Listing";
import CompleteActivity from "./component/Dealer/Activity/Complete";
import RejectActivity from "./component/Dealer/Activity/Reject";
import CreateDealer from "./component/Dealer/Leads/save";
import DealerListing from "./component/Dealer/Leads/List";
import DealerLeadActivityList from "./component/Dealer/Leads/Activity/Listing";
import CompleteDealerLeadActivity from "./component/Dealer/Leads/Activity/Complete";
import RejectDealerLeadActivity from "./component/Dealer/Leads/Activity/Reject";
import RescheduleActivity from "./component/Dealer/Activity/Reschedule";
import RescheduleLeadActivity from "./component/Dealer/Leads/Activity/Reschedule";
import TaggedActivityList from "./component/TaggedAlong/Listing";
import Tagged from "./component/TaggedAlong";
import DealerLeadActivitySave from "./component/Dealer/Leads/Activity/Save";
import HealthCard from "./component/Dealer/HealthCard";
import VerifyUCDDetails from "./component/Dealer/UCD/DealerVerification";
import Save from "./component/Dealer/UCD/DetailsSave";
import UCDListing from "./component/Dealer/UCD/List";
import UCDView from "./component/Dealer/UCD/View";
import Edit from "./component/Dealer/UCD/Edit";
import FastTagTollActivitySave from "./component/FasttagToll/Save";
import CompleteFastTagTollActivity from "./component/FasttagToll/Complete";
import FastTagTollActivityList from "./component/FasttagToll/listing";
import TollCreate from "./component/FasttagToll/Account/Save";
import TollList from "./component/FasttagToll/Account/List";
import TollView from "./component/FasttagToll/Account/View";
import ApprovalPendingList from "./component/FasttagToll/Approval/List";
import ApprovalActivity from "./component/FasttagToll/Approval/Action";
import JourneyTravelled from "./component/JourneyTravelled/";

import ValletAccount from "./component/Valet/Account/Save";
import ValetAccountList from "./component/Valet/Account/Listing";
import ValetAccountView from "./component/Valet/Account/View";
import ValetOpportunities from "./component/Valet/Opportunity";
import ValetOpportunityList from "./component/Valet/Opportunity/Listing";
import ValetActivitySave from "./component/Valet/Activity/Save";
import CompleteValetActivity from "./component/Valet/Activity/Complete";
import ValetActivityList from "./component/Valet/Activity/Listing";
import RejectValetVActivity from "./component/Valet/Activity/Reject";
import Sites from "./component/Valet/Account/ExistingSites";
import siteVisit from "./component/Valet/Account/SiteVisit";
import SiteListList from "./component/Valet/Activity/SiteVisitList";
import SiteVisitView from "./component/Valet/Activity/SiteVisitView";
import ValetExternalMom from "./component/Valet/MOM";
import ExternalMomList from "./component/Valet/MOM/List";
import ExternalMoMView from "./component/Valet/MOM/View";
import ExternalMomListing from "./component/ExternalMomList";

import RescheduleValetActivity from "./component/Valet/Activity/Reschedule";
import CarServiceOpportunities from "./component/CarServices/Opportunity";
import CarServiceOpportunityList from "./component/CarServices/Opportunity/Listing";
import CarServiceActivitySave from "./component/CarServices/Activity/Save";
import CompleteCarServiceActivity from "./component/CarServices/Activity/Complete";
import CarServiceActivityList from "./component/CarServices/Activity/listing";
import CarServiceAccount from "./component/CarServices/Account/Save";
import CarServiceAccountView from "./component/CarServices/Account/View";
import CarServiceAccountList from "./component/CarServices/Account/Listing";
import RejectCarServiceVActivity from "./component/CarServices/Activity/Reject";

import ParkingActivitySave from "./component/Parking/Activity/Save";
import CompleteParkingActivity from "./component/Parking/Activity/Complete";
import ParkingActivityList from "./component/Parking/Activity/Listing";
import RejectParkingVActivity from "./component/Parking/Activity/Reject";
import RescheduleParkingActivity from "./component/Parking/Activity/Reschedule";
import ParkingAccountList from "./component/Parking/Account/Listing";
import ParkingAccount from "./component/Parking/Account/Save";
import NewParkingListing from "./component/Parking/Account/NewParkingListing";

import BAActivitySave from "./component/BA/Activity/Save";
import CompleteBaActivity from "./component/BA/Activity/Complete";
import BaActivityList from "./component/BA/Activity/Listing";
import RescheduleBaActivity from "./component/BA/Activity/Reschedule";
import BaAccountList from "./component/BA/Account/Listing";
import RejectBAVActivity from "./component/BA/Activity/Reject";
import Opportunity from "./component/BA/Opportunity";
import BAOpportunityList from "./component/BA/Opportunity/Listing";
import CompleteBaOpportunity from "./component/BA/Opportunity/Edit";
import CreateMeeting from "./component/Valet/Account/CreateMeeting";
import UCDActivitySave from "./component/Dealer/UCD/Activity/Save";
import CompleteUCDActivity from "./component/Dealer/UCD/Activity/Complete";
import UCDActivityList from "./component/Dealer/UCD/Activity/listing";
// import DCCAtivitySave from "./component/DCC/Activity/Save";
// import CompleteDCCActivity from "./component/DCC/Activity/Complete";
// import DCCActivityList from "./component/DCC/Activity/Listing";
// import RescheduleDCCActivity from "./component/DCC/Activity/Reschedule";
// import RejectDCCVActivity from "./component/DCC/Activity/Reject";

import Journey from "./component/Journey";

import AttendanceRegularizationList from "./component/AttedanceRegularization/List";
import AttendanceRequestApproval from "./component/AttedanceRegularization/Action";

import GeoLocation from "./component/GeoLocation";

import SearchUniverseBusiness from "./component/V2/Business/AccountSearch";
import InspectionList from "./component/AccountAttributes/InspectionList";
import UserRatingList from "./component/Dealer/Leads/UserRatingList";
import SmList from "./component/Dealer/Leads/SmList";
import SmView from "./component/Dealer/Leads/SmView";
import RmList from "./component/Dealer/Leads/RmList";

import PJPSubmission from "./component/FasttagToll/PJP/Submission";
import ReviewPJP from "./component/FasttagToll/PJP/Review";
import PjpPendingList from "./component/FasttagToll/PJP/PendingList";
import PjpApprovedList from "./component/FasttagToll/PJP/Approved";
import AMVisit from "./component/FasttagToll/PJP/Visiting";
import Fse from "./component/FasttagToll/PJP/FSEsDetails";
import PjpRejectedList from "./component/FasttagToll/PJP/Rejected";
import PJPUpdateSubmission from "./component/FasttagToll/PJP/UpdateSubmission";
import PJPView from "./component/FasttagToll/PJP/VisitedView";
import MonthlyRegularization from "./component/MonthlyRegularization";
import MarkRegularization from "./component/MarkRegularization";
import Heatmap from "./component/Heatmap/Heatmap.js";
import AddDealerPoc from './component/Dealer/AddDealerPoc/'
import SaveUCDLead from "./component/Dealer/UCD/Lead/Save";
import UCDLeadListing from "./component/Dealer/UCD/Lead/List";
import ViewUCDLead from "./component/Dealer/UCD/Lead/View";
import UCDLeadActivitySave from "./component/Dealer/UCD/Lead/Activity/Save";
import UCDLeadActivityList from "./component/Dealer/UCD/Lead/Activity/Listing";
import CompleteUCDLeadActivity from "./component/Dealer/UCD/Lead/Activity/Complete";
import PendingList from "./component/Dealer/UCD/Lead/PendingList";
import LeadApproval from "./component/Dealer/UCD/Lead/LeadApproval";
import RmMeetingView from "./component/Dealer/Leads/RmMeetingView/index.js";
import RaiseIssue from "./component/Dealer/Leads/RaiseIssue";
import TicketDetails from "./component/Dealer/Leads/TicketDetails";

import ReferralsOptions from "./component/Referrals/options.js";
import ReferralCreate from "./component/Referrals/ReferralCreate";
import ReferralsStatus from "./component/Referrals/ReferralsStatus";
import ReferralsReceived from "./component/Referrals/ReferralsReceived";
import ReferralsGiven from "./component/Referrals/ReferralsGiven";
import ReferralsAssigned from "./component/Referrals/ReferralsAssigned";
import ReferralDetails from "./component/Referrals/ReferralDetails";
import ReferralsPending from "./component/Referrals/ReferralsPending";

import SitesCalling from "./component/Referrals/SitesCalling";
import SitesCallingForm from "./component/Referrals/SitesCallingForm";
import SitesCallingLog from "./component/Referrals/SitesCallingLog";

import InactiveFse from "./component/FasttagToll/TollEfficiency/InactiveFse";
import Inventory from "./component/FasttagToll/TollEfficiency/Inventory";
import FseTagTransfer from "./component/FasttagToll/TollEfficiency/TagTransafer";
import Penalty from "./component/FasttagToll/TollEfficiency/Penalty";

import UCDCases from "./component/Dealer/UCD/Cases/Create";
import CaseView from "./component/Dealer/UCD/Cases/View";
import CaseListingV2 from "./component/Dealer/UCD/Cases/ListV2";
import CaseListing from "./component/Dealer/UCD/Cases/List";
import CaseEdit from "./component/Dealer/UCD/Cases/Edit";
import RaisePaymentV2 from "./component/Dealer/UCD/Cases/RaisePaymentV2";
import RaisePayment from "./component/Dealer/UCD/Cases/RaisePayment";
import RaisePaymentUpdate from "./component/Dealer/UCD/Cases/RaisePaymentUpdate";
import RcStatusRemark from "./component/Dealer/UCD/Cases/RcStatusRemark";
import Redirect from "./component/Redirect";


import LeadDsmPendingList from "./component/Dealer/Leads/PendingList";
import ApprovalDsmLead from "./component/Dealer/Leads/LeadApproval";
import AddressApprovalPenndingList from "./component/Dealer/Leads/AddressApprovalPenndingList";
import ApprovalAddressDsmLead from "./component/Dealer/Leads/AddressApprovalAction";
import AddressUpdateLogs from "./component/Dealer/Leads/AddressUpdateLogs";
import RegularizationRequestsForManager from "./component/RegularizationRequestsForManager";
import RegularizationApproveReject from "./component/RegularizationApproveReject";
import NotAtSiteAttendance from "./component/NotAtSiteAttendance";
import RegularizationRequestListLogs from "./component/RegularizationRequestListLogs";
import LogsViewDetails from "./component/LogsViewDetails";
import AttendanceRecordDetails from "./component/AttendanceRecordDetails";
import PayoutDetails from "./component/Dealer/UCD/Cases/PayoutDetails";
import RaisePaymentReleaseRequest from "./component/Dealer/UCD/Cases/RaisePaymentReleaseRequest";
import ApprovedList from "./component/Dealer/UCD/ApprovedList";
import ApprovedDealerView from "./component/Dealer/UCD/ApprovedDealerView";
import ChangeAssignee from "./component/Dealer/UCD/ChangeAssignee";
import UnverifiedList from "./component/Dealer/UCD/UnverifiedList";
import LeadList from "./component/LMS/List";
import LeadDetails from "./component/LMS/Details";
import LeadsOptions from "./component/LMS/Options";
import ValetEditAccount from "./component/Valet/Opportunity/SiteDetails";
import  BlockUser  from "./component/BlockUser/BlockUser";

import { FORCE_UPGRADE_MODULE_TYPES } from "./utils/redirection.js";
import { moeAddEmail, moeAddFirstName, moeAddUniqueUserId } from "./utils/moengage";

const App = () => {


    const [roleId, setRoleId] = useState("")
    const [blockUser, setBlockUser] = useState(false)


    const checkForceUpgrade = ()=>{
        const moduleType = window?.localStorage.getItem("module_type") ?? ""
        const webView = window.localStorage?.webview;
        const roleId = window?.localStorage.getItem("role_id")

        if(!!webView && !!roleId && [30,41,7, 46, 47, 29].includes(+roleId) ){ 
            
            if(+roleId === 41){
                let userProfile = localStorage.getItem("user_profile");
                let userDetails = JSON.parse(userProfile);
                const teamIds = userDetails?.teams.map((team) => team.team_id);

                if(teamIds.includes(18) && !teamIds.includes(28)){
                    setBlockUser(true)
                }
            } else if ( +roleId === 7){
                let userProfile = localStorage.getItem("user_profile");
                let userDetails = JSON.parse(userProfile);
                const teamIds = userDetails?.teams.map((team) => team.team_id);

                if(!teamIds.includes(22) && !teamIds.includes(18)){
                    setBlockUser(true)
                }
            } else if([46,47, 29].includes(+roleId)){
                setBlockUser(true)
            }
            else {
                setBlockUser(true)
            }   
         
        }
    }

    useEffect(() => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
    }, [])

    useEffect(() => {
        if(window.localStorage?.user_id){
            moeAddFirstName(window.localStorage?.name);
            moeAddEmail(window.localStorage?.userId);
            moeAddUniqueUserId(window.localStorage?.user_id);
        }

        setTimeout(()=>{
            checkForceUpgrade()
        },2000)

    }, [])


    if(blockUser){
        return <BlockUser/>
    }

    return (
        <>
            <Router>
                <Route exact path="/lead-details/:id" component={LeadDetails}/>
                {(parseInt(roleId) === 79) &&
                    <>
                        <Route exact path="/leads" component={LeadsOptions}/>
                        <Route exact path="/pending-leads" component={LeadList}/>
                        <Route exact path="/verified-leads" component={LeadList}/>
                        <Route exact path="/rejected-leads" component={LeadList}/>
                        <Route exact path="/hold-leads" component={LeadList}/>
                        <Route exact path="/add-account/:lead_id?" component={AccountAttributes}/>
                    </>
                }
                
                <Route exact path="/valet-external-mom/:activity_id" component={ValetExternalMom}/>
                <Route exact path="/external-mom-list/:meeting_id" component={ExternalMomList}/>
                <Route exact path="/external-mom-listing" component={ExternalMomListing}/>
                <Route exact path="/external-mom-view/:meeting_id" component={ExternalMoMView}/>
                <Route exact path="/payment-raise-v2/:id/:dealer_id/:lsq_dealer_id" component={RaisePaymentV2}/>
                <Route exact path="/payment-raise/:id/:dealer_id/:lsq_dealer_id" component={RaisePayment}/>
                <Route exact path="/rc-status-remark/:id/" component={RcStatusRemark}/>
                <Route exact path="/payment-raise-release-request/:id" component={RaisePaymentReleaseRequest}/>
                {/*<Route exact path="/payment-raise-update/:id" component={RaisePaymentUpdate}/>*/}


                <Route exact path="/dsm-lead-pending" component={LeadDsmPendingList}/>
                <Route exact path="/dsm-lead-approval/:id" component={ApprovalDsmLead}/>
                <Route exact path="/dsm-lead-address-approval-list" component={AddressApprovalPenndingList}/>
                <Route exact path="/dsm-lead-address-approval/:id" component={ApprovalAddressDsmLead}/>
                <Route exact path="/address-update-logs/:lead_id" component={AddressUpdateLogs}/>

                <Route exact path="/ucd-add-case/:id/:dealer_id" component={UCDCases}/>
                <Route exact path="/ucd-case-view/:id" component={CaseView}/>
                <Route exact path="/ucd-case-list-v2/:dealer_id/:id" component={CaseListingV2}/>
                <Route exact path="/ucd-case-list/:dealer_id/:id" component={CaseListing}/>
                <Route exact path="/ucd-case-edit/:id/:lsq_dealer_id" component={CaseEdit}/>
                <Route exact path="/payout-details/:id" component={PayoutDetails}/>
                <Route exact path="/ucd-change-assignee" component={ChangeAssignee}/>

                <Route exact path="/" component={Login}/>
                <Route exact path="/geo-location" component={GeoLocation}/>
                <Route exact path="/sso-login" component={LoginSso}/>
                <Route exact path="/login-otp" component={LoginOtp}/>
                <Route exact path="/home" component={Home}/>
                <Route exact path="/profile" component={Profile}/>
                <Route exact path="/notification" component={Notification}/>
                <Route exact path="/dashboard" component={Dashboard}/>
                <Route exact path="/tagged-along-activity/" component={TaggedActivityList}/>
                <Route exact path="/view-tagged-along-activity/:id/:tagged_id" component={Tagged}/>

                <Route exact path="/attendance-regularization-request" component={AttendanceRegularizationList}/>
                <Route exact path="/attendance-regularization-approval/:id" component={AttendanceRequestApproval}/>

                {/* DARWIN ROUTES STARTS */}
                <Route exact path="/monthly-regularization/" component={MonthlyRegularization}/>
                <Route exact path="/attendance-record-details/:key" component={AttendanceRecordDetails}/>
                <Route exact path="/mark-regularization/:date" component={MarkRegularization}/>
                <Route exact path="/manager-requests-list" component={RegularizationRequestsForManager}/>
                <Route exact path="/request-list-logs" component={RegularizationRequestListLogs}/>
                <Route exact path="/not-at-site-attendance" component={NotAtSiteAttendance}/>
                <Route exact path="/regularization-approve-reject/:id/:type" component={RegularizationApproveReject}/>
                <Route exact path="/logs-view-details/:id/:type" component={LogsViewDetails}/>
                {/* DARWIN ROUTES ENDS */}

                <Route exact path="/referrals-options" component={ReferralsOptions}/>
                <Route exact path="/new-referral" component={ReferralCreate}/>
                <Route exact path="/referrals-status" component={ReferralsStatus}/>
                <Route exact path="/referrals-pending" component={ReferralsPending}/>
                <Route exact path="/referrals-received" component={ReferralsReceived}/>
                <Route exact path="/referrals-given" component={ReferralsGiven}/>
                <Route exact path="/referrals-assigned" component={ReferralsAssigned}/>
                <Route exact path="/referrals-view/:id" component={ReferralDetails}/>
                <Route exact path="/referrals-sites-calling" component={SitesCalling}/>
                <Route exact path="/referral-call-form/:id" component={SitesCallingForm}/>
                <Route exact path="/view-call-logs/:id" component={SitesCallingLog}/>
                <Route exact path="/redirect" component={Redirect} />

                {/*<Route exact path="/dcc-activity-save/:account_id" component={DCCAtivitySave}/>*/}
                {/*<Route exact path="/dcc-activity-complete/:account_id/:id" component={CompleteDCCActivity}/>*/}
                {/*<Route exact path="/dcc-activity-list/:account_id" component={DCCActivityList}/>*/}
                {/*<Route exact path="/dcc-activity-reschedule/:account_id/:id" component={RescheduleDCCActivity}/>*/}
                {/*<Route exact path="/dcc-activity-reject/:account_id/:id" component={RejectDCCVActivity}/>*/}

                {(parseInt(roleId) === 15 || parseInt(roleId) === 17 || parseInt(roleId) === 16 || parseInt(roleId) === 14 || parseInt(roleId) === 56) &&
                    <>
                        <Route exact path="/journey" component={Journey}/>
                        {/*<Route exact path="/ba-activity-save/:lead_id" component={BAActivitySave}/>*/}
                        {/*<Route exact path="/ba-activity-complete/:lead_id/:id" component={CompleteBaActivity}/>*/}
                        {/*<Route exact path="/ba-activity-list/:lead_id" component={BaActivityList}/>*/}
                        {/*<Route exact path="/ba-activity-reschedule/:lead_id/:id" component={RescheduleBaActivity}/>*/}
                        {/*<Route exact path="/ba-activity-reject/:lead_id/:id" component={RejectBAVActivity}/>*/}
                        <Route exact path="/ba-account-list" component={BaAccountList}/>
                        <Route exact path="/save-opportunity/:lead_id" component={Opportunity}/>
                        <Route exact path="/ba-opportunity-list/:lead_id" component={BAOpportunityList}/>
                        <Route exact path="/edit-opportunity/:id" component={CompleteBaOpportunity}/>
                        <Route exact path="/view-opportunity/:id" component={CompleteBaOpportunity}/>
                    </>
                }

                {(parseInt(roleId) === 35 || parseInt(roleId) === 36 || parseInt(roleId) === 37 || parseInt(roleId) === 38 || parseInt(roleId) === 48) &&
                    <>
                        {localStorage.setItem("module_type", "Parking")}
                        <Route exact path="/journey" component={Journey}/>
                        <Route exact path="/parking-account-list" component={ParkingAccountList}/>
                        <Route exact path="/parking-activity-save/:account_id" component={ParkingActivitySave}/>
                        <Route exact path="/parking-activity-complete/:id/:account_id"
                               component={CompleteParkingActivity}/>
                        <Route exact path="/parking-activity-list/:account_id" component={ParkingActivityList}/>
                        <Route exact path="/parking-activity-reject/:id" component={RejectParkingVActivity}/>
                        <Route exact path="/parking-activity-reschedule/:id" component={RescheduleParkingActivity}/>
                        <Route exact path="/save-parking-site/" component={ParkingAccount}/>
                        <Route exact path="/view-parking/:id" component={ParkingAccount}/>
                        <Route exact path="/edit-parking/:id" component={ParkingAccount}/>
                        <Route exact path="/new-parking-account-list" component={NewParkingListing}/>
                    </>
                }

                {(parseInt(roleId) === 46 || parseInt(roleId) === 47 || parseInt(roleId) === 76) &&
                    <>
                        {localStorage.setItem("module_type", "valet")}
                        <Route exact path="/journey" component={Journey}/>
                        <Route exact path="/valet_account-save" component={ValletAccount}/>
                        <Route exact path="/valet_account-update/:id" component={ValletAccount}/>
                        <Route exact path="/valet_account-edit/:id" component={ValetEditAccount}/>
                        <Route exact path="/valet_account-list" component={ValetAccountList}/>
                        <Route exact path="/valet_account-view/:id" component={ValetAccountView}/>
                        <Route exact path="/valet-opportunity/:id" component={ValetOpportunities}/>
                        <Route exact path="/valet-opportunity-list/:id" component={ValetOpportunityList}/>
                        <Route exact path="/valet-activity-save/:opportunity_id/:account_id"
                               component={ValetActivitySave}/>
                        <Route exact path="/valet-activity-complete/:id/:account_id" component={CompleteValetActivity}/>
                        <Route exact path="/valet-activity-list/:opportunity_id/:account_id"
                               component={ValetActivityList}/>
                        <Route exact path="/valet-activity-reject/:id/" component={RejectValetVActivity}/>
                        <Route exact path="/valet-activity-reschedule/:id/:opportunity_id/:account_id"
                               component={RescheduleValetActivity}/>
                        <Route exact path="/valet-existing-sites/" component={Sites}/>
                        <Route exact path="/site-visit/:id" component={siteVisit}/>
                        <Route exact path="/create-meeting/:id" component={CreateMeeting}/>
                        {/*<Route exact path="/check-in-site_visit/:id" component={CheckinSiteVisit}/>*/}
                        <Route exact path="/site-visit-list/:id" component={SiteListList}/>
                        <Route exact path="/site-visit-view/:id" component={SiteVisitView}/>
                        {/*<Route exact path="/checkout-view" component={Checkout}/>*/}
                    </>
                }

                {(parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 4 || parseInt(roleId) === 5) &&
                    <>
                        {localStorage.setItem("module_type", "car service")}
                        <Route exact path="/journey" component={Journey}/>
                        <Route exact path="/car-service-opportunity/:id" component={CarServiceOpportunities}/>
                        <Route exact path="/car-service-opportunity-list/:id" component={CarServiceOpportunityList}/>
                        <Route exact path="/car-service-activity-save/:opportunity_id/:account_id"
                               component={CarServiceActivitySave}/>
                        <Route exact path="/car-service-activity-complete/:id/:account_id"
                               component={CompleteCarServiceActivity}/>
                        <Route exact path="/car-service-activity-list/:opportunity_id/:account_id"
                               component={CarServiceActivityList}/>
                        <Route exact path="/car-service-account-save" component={CarServiceAccount}/>
                        <Route exact path="/car-service-account-update/:id" component={CarServiceAccount}/>
                        <Route exact path="/car-service-account-view/:id" component={CarServiceAccountView}/>
                        <Route exact path="/car-service-account-list/" component={CarServiceAccountList}/>
                        <Route exact path="/car-service-activity-reject/:id" component={RejectCarServiceVActivity}/>
                    </>
                }

                {(parseInt(roleId) === 29 || parseInt(roleId) === 30 || parseInt(roleId) === 42 || parseInt(roleId) === 43 || parseInt(roleId) === 67) &&
                    <>
                        {localStorage.setItem("module_type", "fasttag toll")}
                        <Route exact path="/journey" component={Journey}/>
                        <Route exact path="/fast-tag-toll-activity/:account_id" component={FastTagTollActivitySave}/>
                        <Route exact path="/fast-tag-toll-activity-complete/:id/:account_id"
                               component={CompleteFastTagTollActivity}/>
                        <Route exact path="/fast-tag-toll-activity-list/:account_id"
                               component={FastTagTollActivityList}/>
                        <Route exact path="/fast-tag-toll-save/:account_id?" component={TollCreate}/>
                        <Route exact path="/fast-tag-toll-list/" component={TollList}/>
                        <Route exact path="/fast-tag-toll-list/:is_approval" component={TollList}/>
                        <Route exact path="/fast-tag-toll-view/:id" component={TollView}/>
                        <Route exact path="/reschedule-activity/:id/:module_id/:type" component={RescheduleActivity}/>
                        <Route exact path="/reject-dealer-activity/:id/:type" component={RejectActivity}/>
                        <Route exact path="/activity-approval/:id" component={ApprovalActivity}/>
                        <Route exact path="/approved-pending-list" component={ApprovalPendingList}/>
                        <Route exact path="/get-journey" component={JourneyTravelled}/>

                        <Route exact path="/pjp-submission/" component={PJPSubmission}/>
                        <Route exact path="/pjp-submission-update/:user_id" component={PJPUpdateSubmission}/>
                        <Route exact path="/pjp-review" component={ReviewPJP}/>
                        <Route exact path="/pjp-pending-list/:request_id/:user_id?" component={PjpPendingList}/>
                        <Route exact path="/pjp-approved-list/:request_id/:user_id?" component={PjpApprovedList}/>
                        <Route exact path="/pjp-rejected-list/:request_id/:user_id?" component={PjpRejectedList}/>
                        <Route exact path="/pjp-visit/:account_id/:pjp_id/:request_id" component={AMVisit}/>
                        <Route exact path="/fse-details/:id/:account_id" component={Fse}/>
                        <Route exact path="/view/:pjp_id" component={PJPView}/>

                        <Route exact path="/inactive-fse/:id" component={InactiveFse}/>
                        <Route exact path="/fse-inventory/:id" component={Inventory}/>
                        <Route exact path="/fse-tag-transfer/:id" component={FseTagTransfer}/>
                        <Route exact path="/fse-penalty/:id" component={Penalty}/>

                    </>
                }


                {(parseInt(roleId) === 42) &&
                    <>
                        {localStorage.setItem("module_type", "fasttag toll")}
                        <Route exact path="/journey" component={Journey}/>
                        <Route exact path="/fast-tag-toll-activity/:account_id" component={FastTagTollActivitySave}/>
                        <Route exact path="/fast-tag-toll-activity-complete/:id/:account_id"
                               component={CompleteFastTagTollActivity}/>
                        <Route exact path="/fast-tag-toll-activity-list/:account_id"
                               component={FastTagTollActivityList}/>
                        <Route exact path="/fast-tag-toll-save/:account_id?" component={TollCreate}/>
                        <Route exact path="/fast-tag-toll-list/" component={TollList}/>
                        <Route exact path="/fast-tag-toll-view/:id" component={TollView}/>

                        <Route exact path="/pjp-submission/" component={PJPSubmission}/>
                        <Route exact path="/pjp-submission-update/:user_id" component={PJPUpdateSubmission}/>
                        <Route exact path="/pjp-review" component={ReviewPJP}/>
                        <Route exact path="/pjp-pending-list/:request_id/:user_id?" component={PjpPendingList}/>
                        <Route exact path="/pjp-approved-list/:request_id/:user_id?" component={PjpApprovedList}/>
                        <Route exact path="/pjp-rejected-list/:request_id/:user_id?" component={PjpRejectedList}/>
                        <Route exact path="/pjp-visit/:account_id/:pjp_id" component={AMVisit}/>
                        <Route exact path="/fse-details/:id/:account_id" component={Fse}/>
                        <Route exact path="/view/:pjp_id" component={PJPView}/>
                    </>
                }


                {(parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6 || parseInt(roleId) === 54 || parseInt(roleId) === 55) &&
                    <>
                        {localStorage.setItem("module_type", "dealer")}
                        <Route exact path="/journey" component={Journey}/>
                        <Route exact path="/dealer-list/:dealer_type" component={Dealer}/>
                        <Route exact path="/add-poc/:dealer_id" component={AddDealerPoc}/>
                        <Route exact path="/dealer-activity/:module_id/:dealer_type" component={ActivitySave}/>
                        <Route exact path="/edit-dealer-activity/:module_id/:is_edit" component={CompleteActivity}/>
                        <Route exact path="/dealer-activity-list/:dealer_id" component={DealerActivityList}/>
                        <Route exact path="/complete-dealer-activity/:module_id" component={CompleteActivity}/>
                        <Route exact path="/reject-dealer-activity/:id/:type" component={RejectActivity}/>
                        <Route exact path="/dealer" component={CreateDealer}/>
                        <Route exact path="/edit-dealer/:id" component={CreateDealer}/>
                        <Route exact path="/dealer-lead-list" component={DealerListing}/>
                        <Route exact path="/dealer-lead-activity/:id" component={DealerLeadActivitySave}/>
                        <Route exact path="/dealer-lead-activity-list/:id" component={DealerLeadActivityList}/>
                        <Route exact path="/dealer-lead-activity-complete/:id" component={CompleteDealerLeadActivity}/>
                        <Route exact path="/edit-dealer-lead-activity-complete/:id/:is_edit"
                               component={CompleteDealerLeadActivity}/>
                        <Route exact path="/dealer-lead-activity-reject/:id" component={RejectDealerLeadActivity}/>
                        <Route exact path="/reschedule-activity/:id/:module_id/:type" component={RescheduleActivity}/>
                        <Route exact path="/reschedule-lead-activity/:id/:module_id"
                               component={RescheduleLeadActivity}/>
                        <Route exact path="/health-card/:id" component={HealthCard}/>
                        <Route exact path="/ucd-dealer-verify/:lead_id?" component={VerifyUCDDetails}/>
                        <Route exact path="/ucd-dealer-details/:ucd_id/:lead_id?" component={Save}/>
                        <Route exact path="/ucd-dealer-list/" component={UCDListing}/>
                        <Route exact path="/ucd-dealer-view/:id" component={UCDView}/>
                        <Route exact path="/ucd-dealer-edit/:id" component={Edit}/>
                        <Route exact path="/ucd-approval-list/" component={ApprovedList}/>
                        <Route exact path="/ucd-unverified-list/" component={UnverifiedList}/>
                        <Route exact path="/approved-dealer-view/:dealer_id" component={ApprovedDealerView}/>
                        {/* <Route exact path="/ucd-activity-list/:id?" component={UCDActivityList}/> */}

                        <Route exact path="/save-ucd-activity/:id" component={UCDActivitySave}/>

                        <Route exact path="/complete-ucd-activity/:account_id/:id" component={CompleteUCDActivity}/>
                        <Route exact path="/ucd-activity-list/:account_id" component={UCDActivityList}/>

                        <Route exact path="/ucd-lead-save" component={SaveUCDLead}/>
                        <Route exact path="/ucd-lead-list" component={UCDLeadListing}/>
                        <Route exact path="/ucd-lead-view/:id" component={ViewUCDLead}/>
                        <Route exact path="/ucd-lead-activity-save/:id" component={UCDLeadActivitySave}/>
                        <Route exact path="/ucd-lead-activity-list/:id" component={UCDLeadActivityList}/>
                        <Route exact path="/ucd-lead-activity-complete/:id/:lead_id"
                               component={CompleteUCDLeadActivity}/>
                        <Route exact path="/ucd-lead-pending-list" component={PendingList}/>
                        <Route exact path="/ucd-lead-approval/:id" component={LeadApproval}/>

                    </>
                }

                <Route exact path="/users-list" component={UserRatingList}/>
                <Route exact path="/sm-list/:id?" component={SmList}/>
                <Route exact path="/sm-view/:id?/:is_rating?" component={SmView}/>
                <Route exact path="/rm-details" component={RmList}/>

                <Route exact path="/raise-issue" component={RaiseIssue}/>
                <Route exact path="/ticket-details" component={TicketDetails}/>


                {(parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4) &&
                    <>
                        <Route exact path="/create-lead/" component={CreateLeads}/>
                        <Route exact path="/edit-lead/:id" component={CreateLeads}/>
                        <Route exact path="/inspect-lead/:id" component={BusinessConfig}/>
                        <Route exact path="/inspect-lead-create/:lead_id" component={BusinessConfig}/>
                        <Route exact path="/inspection-form/:id" component={BusinessConfigInspection}/>
                        <Route exact path="/lead-activity-save/:id/:lead_id" component={ActivityCreate}/>
                        <Route exact path="/lead-list/" component={LeadListing}/>
                        <Route exact path="/lead-activity-list/:id" component={ActivityListing}/>
                        <Route exact path="/new-lead-activity/:lead_id" component={LeadNewActivity}/>
                    </>
                }

                {(parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4) &&
                    <>
                        <Route exact path="/add-account/:lead_id?" component={AccountAttributes}/>
                        <Route exact path="/edit-account/:id/:lead_id?" component={AccountAttributes}/>
                    </>
                }
                {/*<Route exact path="/account-activity-save/:id/:account_id" component={ActivityAccountCreate}/>*/}
                <Route exact path="/list-account/:lead_id?" component={AccountList}/>
                <Route exact path="/pie-list-account/:stage_id" component={AccountList}/>
                <Route exact path="/view-account/:id/:lead_id?" component={AccountAttributes}/>
                <Route exact path="/inspection-list/:id" component={InspectionList}/>
                <Route exact path="/add-opportunity/:id/:lead_id?" component={CreateOpportunities}/>
                <Route exact path="/edit-opportunity/:account_id/:opportunity_id/:lead_id?"
                       component={EditOpportunities}/>
                <Route exact path="/view-opportunity/:account_id/:opportunity_id/:lead_id?"
                       component={EditOpportunities}/>
                <Route exact path="/opportunity-list/:id/:lead_id?" component={OpportunityList}/>
                <Route exact path="/activity-list/:opportunity_id/:account_id/:lead_id?" component={List}/>

                <Route exact path="/view-activity/:id?" component={ActivityView}/>
                <Route exact path="/rm-view-activity/:id?" component={RmMeetingView}/>


                {/*<Route exact path="/account-activity-list/:id" component={ActivityAccountListing}/>*/}
                {/*<Route exact path="/add-next-activity/:account_id/:opportunity_id/:activity_id/:type_id/:lead_id?"*/}
                {/*       component={AddNextActivity}/>*/}
                <Route exact path="/post-closure/:account_id/:opportunity_id/:lead_id?"
                       component={PostClosure}/>

                <Route exact path="/reject-activity/:account_id/:opportunity_id/:activity_id/:type_id/:lead_id?"
                       component={Reject}/>
                <Route exact path="/new-opportunity-activity/:account_id/:opportunity_id/"
                       component={opportunityNewActivity}/>
                {/*<Route exact path="/new-account-activity/:account_id" component={AccountNewActivity}/>*/}
                <Route exact path="/opportunity-view/:id" component={View}/>


                {/* for v2 */}
                {/*<Route exact path="/v2-opportunity-activity-view/:id" component={OpportunityActivityView}/>*/}
                <Route exact path="/v2-add-next-activity/:account_id/:opportunity_id/:lead_id?"
                       component={V2OpportunityActivity}/>
                <Route exact path="/v2-activity-list/:opportunity_id/:account_id/:lead_id?"
                       component={V2OpportunityActivityList}/>
                {/*<Route exact path="/lead-add-opportunity/:id/" component={CreateLeadOpportunities}/>*/}
                {/*<Route exact path="/lead-list-opportunity/:id/" component={LeadOpportunityList}/>*/}
                {/*<Route exact path="/lead-add-activity/:id/:opportunity_id" component={LeadActivity}/>*/}
                {/*<Route exact path="/lead-list-activity/:id/:opportunity_id" component={V2OpportunityActivityList}/>*/}
                <Route exact path="/v2-opportunity-activity-view/:id/:is_show_opp?" component={V2ActivityView}/>
                <Route exact path="/last-meeting-history/:id" component={LastActivityHistory}/>

                {(parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4
                        || parseInt(roleId) === 17 || parseInt(roleId) === 15) &&
                    <>
                        <Route exact path="/save-task/" component={CreateTask}/>
                        <Route exact path="/edit-task/:id" component={EditTask}/>
                        <Route exact path="/task-list/:type" component={Listing}/>
                        <Route exact path="/task-view/:id/:type" component={ViewListing}/>
                        <Route exact path="/heatmap" component={Heatmap}/>

                    </>
                }

                <Route exact path="/search-universe-business" component={SearchUniverseBusiness}/>
                <Route exact path="/assignment" component={Assignment}/>
                {/*<Route path="*" element={<PageNotFound />} />*/}
                {/*<Route path="*" component={PageNotFound} />*/}

                <ProtectedRoute exact path="/employees" component={Employee}/>
            </Router>
            {/* <script id="moengage">
                {`!(function(e,n,i,t,a,r,o,d){var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js","Moengage"))
              Moengage = moe({
              app_id: '${process.env.MOENGAGE_APP_ID}',
              debug_logs: '${process.env.MOENGAGE_DEBUG_LOGS}'
              });`}
            </script> */}
        </>
    );
}

export default App;